import styled from 'styled-components';

const Section = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export { Section };
